module.exports = "/lucky-balls/img/intro.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/intro.jpg
// module id = 1100
// module chunks = 0